'use es6';

import { getPluginSetting } from '../utils';
import { PASTE_SETTINGS } from '../constants/hspaste';
export function getPastePluginSetting(editor, setting) {
  const pastePluginSettings = getPluginSetting(editor, PASTE_SETTINGS);
  if (pastePluginSettings) {
    return pastePluginSettings[setting];
  }
  return null;
}
export const handleImageSources = (editor, urlEntries) => {
  const {
    dom
  } = editor;
  urlEntries.forEach(urlEntry => {
    const {
      originalUrl,
      fileManagerUrl
    } = urlEntry;
    const imgElement = dom.$(`img[src*='${originalUrl}']`);
    dom.setAttrib(imgElement, 'src', fileManagerUrl);
  });
};